"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: gift-card/catalog.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fgift-card%2Fcatalog.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogTypeToJSON = exports.catalogTypeFromJSON = exports.DenominationsFixedAmount = exports.DenominationsFixed = exports.DenominationsRange = exports.Denominations = exports.CardProduct = exports.GiftCardCatalog = exports.CatalogType = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.giftcard.catalog.proto';
/**
 * The catalog type.
 */
var CatalogType;
(function (CatalogType) {
    CatalogType["INVALID_CATALOG_TYPE"] = "INVALID_CATALOG_TYPE";
    CatalogType["DEFAULT"] = "DEFAULT";
    CatalogType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CatalogType || (exports.CatalogType = CatalogType = {}));
function createBaseGiftCardCatalog() {
    return { cards: [] };
}
exports.GiftCardCatalog = {
    fromJSON(object) {
        const message = {
            cards: globalThis.Array.isArray(object?.cards)
                ? object.cards.map((e) => exports.CardProduct.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cards?.length) {
            obj.cards = message.cards.map((e) => exports.CardProduct.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardCatalog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardCatalog();
        message.cards = object.cards?.map((e) => exports.CardProduct.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCardProduct() {
    return {
        id: '',
        name: '',
        cardImageUrl: '',
        denominations: exports.Denominations.fromPartial({}),
        termsConditions: '',
        termsConditionsFormatted: '',
    };
}
exports.CardProduct = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            cardImageUrl: isSet(object.cardImageUrl) ? globalThis.String(object.cardImageUrl) : '',
            denominations: isSet(object.denominations)
                ? exports.Denominations.fromJSON(object.denominations)
                : exports.Denominations.fromPartial({}),
        };
        if (isSet(object.termsConditions)) {
            message.termsConditions = globalThis.String(object.termsConditions);
        }
        if (isSet(object.termsConditionsFormatted)) {
            message.termsConditionsFormatted = globalThis.String(object.termsConditionsFormatted);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.cardImageUrl !== '') {
            obj.cardImageUrl = message.cardImageUrl;
        }
        if (message.denominations !== undefined) {
            obj.denominations = exports.Denominations.toJSON(message.denominations);
        }
        if (message.termsConditions !== undefined && message.termsConditions !== '') {
            obj.termsConditions = message.termsConditions;
        }
        if (message.termsConditionsFormatted !== undefined && message.termsConditionsFormatted !== '') {
            obj.termsConditionsFormatted = message.termsConditionsFormatted;
        }
        return obj;
    },
    create(base) {
        return exports.CardProduct.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardProduct();
        message.id = object.id ?? '';
        message.name = object.name ?? '';
        message.cardImageUrl = object.cardImageUrl ?? '';
        message.denominations = (object.denominations !== undefined && object.denominations !== null)
            ? exports.Denominations.fromPartial(object.denominations)
            : exports.Denominations.fromPartial({});
        message.termsConditions = object.termsConditions ?? '';
        message.termsConditionsFormatted = object.termsConditionsFormatted ?? '';
        return message;
    },
};
function createBaseDenominations() {
    return { range: undefined, fixed: undefined };
}
exports.Denominations = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.range)) {
            message.range = exports.DenominationsRange.fromJSON(object.range);
        }
        if (isSet(object.fixed)) {
            message.fixed = exports.DenominationsFixed.fromJSON(object.fixed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.range !== undefined) {
            obj.range = exports.DenominationsRange.toJSON(message.range);
        }
        if (message.fixed !== undefined) {
            obj.fixed = exports.DenominationsFixed.toJSON(message.fixed);
        }
        return obj;
    },
    create(base) {
        return exports.Denominations.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDenominations();
        message.range = (object.range !== undefined && object.range !== null)
            ? exports.DenominationsRange.fromPartial(object.range)
            : undefined;
        message.fixed = (object.fixed !== undefined && object.fixed !== null)
            ? exports.DenominationsFixed.fromPartial(object.fixed)
            : undefined;
        return message;
    },
};
function createBaseDenominationsRange() {
    return { productId: '', min: amount_1.Amount.fromPartial({}), max: amount_1.Amount.fromPartial({}) };
}
exports.DenominationsRange = {
    fromJSON(object) {
        const message = {
            productId: isSet(object.productId) ? globalThis.String(object.productId) : '',
            min: isSet(object.min) ? amount_1.Amount.fromJSON(object.min) : amount_1.Amount.fromPartial({}),
            max: isSet(object.max) ? amount_1.Amount.fromJSON(object.max) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.productId !== '') {
            obj.productId = message.productId;
        }
        if (message.min !== undefined) {
            obj.min = amount_1.Amount.toJSON(message.min);
        }
        if (message.max !== undefined) {
            obj.max = amount_1.Amount.toJSON(message.max);
        }
        return obj;
    },
    create(base) {
        return exports.DenominationsRange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDenominationsRange();
        message.productId = object.productId ?? '';
        message.min = (object.min !== undefined && object.min !== null)
            ? amount_1.Amount.fromPartial(object.min)
            : amount_1.Amount.fromPartial({});
        message.max = (object.max !== undefined && object.max !== null)
            ? amount_1.Amount.fromPartial(object.max)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseDenominationsFixed() {
    return { amounts: [], fixedAmounts: [] };
}
exports.DenominationsFixed = {
    fromJSON(object) {
        const message = {
            amounts: globalThis.Array.isArray(object?.amounts)
                ? object.amounts.map((e) => amount_1.Amount.fromJSON(e))
                : [],
            fixedAmounts: globalThis.Array.isArray(object?.fixedAmounts)
                ? object.fixedAmounts.map((e) => exports.DenominationsFixedAmount.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amounts?.length) {
            obj.amounts = message.amounts.map((e) => amount_1.Amount.toJSON(e));
        }
        if (message.fixedAmounts?.length) {
            obj.fixedAmounts = message.fixedAmounts.map((e) => exports.DenominationsFixedAmount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.DenominationsFixed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDenominationsFixed();
        message.amounts = object.amounts?.map((e) => amount_1.Amount.fromPartial(e)) || [];
        message.fixedAmounts =
            object.fixedAmounts?.map((e) => exports.DenominationsFixedAmount.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDenominationsFixedAmount() {
    return { productId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.DenominationsFixedAmount = {
    fromJSON(object) {
        const message = {
            productId: isSet(object.productId) ? globalThis.String(object.productId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.productId !== '') {
            obj.productId = message.productId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.DenominationsFixedAmount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDenominationsFixedAmount();
        message.productId = object.productId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function catalogTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CATALOG_TYPE':
            return CatalogType.INVALID_CATALOG_TYPE;
        case 1:
        case 'DEFAULT':
            return CatalogType.DEFAULT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CatalogType.UNRECOGNIZED;
    }
}
exports.catalogTypeFromJSON = catalogTypeFromJSON;
function catalogTypeToJSON(object) {
    switch (object) {
        case CatalogType.INVALID_CATALOG_TYPE:
            return 'INVALID_CATALOG_TYPE';
        case CatalogType.DEFAULT:
            return 'DEFAULT';
        case CatalogType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.catalogTypeToJSON = catalogTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=catalog.js.map